import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-window',
  templateUrl: './block-window.component.html',
  styleUrls: ['./block-window.component.css']
})
export class BlockWindowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
